<template>
  <v-container ref="itercontainer">
    <v-data-iterator
      :items="items"
      :items-per-page.sync="ipp"
      :page.sync="page"
      hide-default-footer
      class="d-flex flex-column overflow-hidden" :class="short ? 'mh-200' : 'mh-100'"
    >
      <template v-slot:header v-if="title != undefined">
        <slot name="topbar" id="topbar">
          <v-toolbar dark color="blue darken-3" class="shrink mb-1">
            <div class="headline white--text mr-2 text-truncate">
              {{title == null ? 'Title' : title}}
            </div>
          </v-toolbar>
        </slot>
      </template>
      
      <template v-slot:default="props" >
        <v-row class="fill-height overflow-auto" >
          <v-col
            v-for="item in props.items"
            :key="item._id"
            :cols="12 / itemsPerRow"
            class="py-2"
          >
          <component  :is="displayItem" :item="item" ref="iteritem"/>
          </v-col>
        </v-row>
      </template>
      
      <template v-slot:footer ref="iterfooter">
        <v-row
          class="no-gutters mt-auto py-2 shrink"
          align="center"
          justify="center"
        >

          <v-spacer></v-spacer>
          <span class="mr-4 grey--text">
            Page {{ page }} of
            <span
              v-text="numberOfPages"
              class="font-weight-bold primary--text"
            ></span>
          </span>
          <v-btn
            small
            dark
            rounded
            color="blue darken-3"
            class="mr-1"
            @click="formerPage"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn
            small
            dark
            rounded
            color="blue darken-3"
            class="ml-1"
            @click="nextPage"
          >
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-row>
      </template>
    </v-data-iterator>
  </v-container>
</template>

<script>
export default {
  props: ['title', 'items', 'displayItem', 'height', 'short', 'extra'],
  data() {
    return {
      bottom: false,
      rowsPerPageArray: [2, 3, 4, 5, 6],
      rpp: 4,
      page: 1,
      busy: false,
    }
  },
  computed: {
    numberOfPages() {
      return Math.ceil(this.items.length / this.ipp)
    },
    rowsPerPage() {
      return this.rpp
    },
    itemsPerRow() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 1
        case "sm":
          return 2
        case "md":
          return 2
        case "lg":
          return 3
        case "xl":
          return 3
      }
    },
    ipp: {
      get: function () {
        return Math.ceil(this.rowsPerPage * this.itemsPerRow)
      },
      set: function () {},
    },
  },
  methods: {
    onResize () {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight }
      if (this.windowSize.y != this.lastheight) {
        this.height = this.windowSize.y
        this.lastheight = this.height
        this.wheight = window.innerHeight - 200
        this.wwidth = this.windowSize.x
      }
    },
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) this.page += 1;
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1;
    },
    calcRowsPerPage() {
      let minItemHeight = this.height || 200
      console.log('item height: ', this.$refs.iteritem)
      let containerHeight = window.innerHeight -300
      this.rpp = Math.floor(
        (Math.max(containerHeight, minItemHeight) ) / minItemHeight
      );
      console.log('rows per page: ' + this.rpp)
    },
  },
  mounted() {
    this.calcRowsPerPage()
    window.addEventListener("resize", () => {
      //debounce
      console.log(window.innerHeight, window.innerWidth)
      if (!this.busy) {
        this.busy = true;
        setTimeout(() => {
          this.calcRowsPerPage();
          this.busy = false;
        }, 300);
      }
    });
  },
};
</script>
<style >
.mh-100 {
  height: calc(100vh - 100px);
  max-height: calc(100vh - 100px);
}

.mh-200 {
  /* height: calc(100vh - 250px);
  max-height: calc(100vh - 250px); */
}

.overflow-hidden {
  overflow: hidden;
}

.theme--light.v-application {
  background-color: #ddd;
}
</style>